module.exports = __webpack_public_path__ + "img/switch-control-select-type.646f1b2f.svg";